import CreateAndEditGenreModal from "./create-and-edit-genre-modal/create-and-edit-genre-modal";

export { GenreTable } from "./genre-table/genre-table";
export { CreateAndEditGenreModal }